import React from "react"
import { NumberFieldSeeker } from "@ui-seeker/core"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { object, string } from "yup"


export default function ReportLimitHoursField() {

	const {
		hoursLimit,
		setHoursLimitInfo,
		error
	} = useReportFormInfo(
		reportFormData.peek().hoursLimit,
		"hoursLimit",
		object({
			hoursLimit: string().nullable().test('hoursLimit', 'The hour must be between 2 and 7, both included', hour => !hour || hour >= 2 && hour <= 7)
		}))

	return <NumberFieldSeeker
		label="Limit Hours"
		value={hoursLimit || ""}
		onChange={e => setHoursLimitInfo(e.target.value)}
		error={error}
	/>
}